<ngx-slick-carousel id="slide-main" class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
    (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
    <div ngxSlickItem *ngFor="let slide of slides; let i = index" class="slide">
        <h1 class="sr-only"><span>Sorteo Anáhuac 10ª Edición</span></h1>

<!-- 
        <section id="slider-awards" *ngIf="slide.id == 1" style="background-image: url({{slide.bg}});">

            <div class="container">
                <div class="row">
                    <div class="col-lg-6 text-center my-auto d-lg-block d-none">
                        <div class="content-img  h-100">
                            <img src="{{slide.img}}" class="img-fluid ">
                        </div>
                    </div>
                    <div class="col-lg-6 text-center my-auto">
                        <div class="content-img  h-100">
                            <a routerLink="/lista-ganadores-primer-sorteo-oportuno-2025">
                                <img src="{{slide.img2}}" class="img-fluid ">

                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </section>
 -->

        <section id="slider-awards" *ngIf="slide.id == 1" style="background-image: url({{slide.bg}});">

            <div class="container">
                <div class="row">
                    <div class="col-md-6 text-center my-auto">
                        <div class="content-img  h-100">
                            <img src="{{slide.logo}}" class="img-fluid d-md-block d-none">
                            <img src="{{slide.sorteos}}" class="img-fluid ">
                            <img src="{{slide.price}}" class="img-fluid d-md-block d-none">
                        </div>
                    </div>
                    <div class="col-md-6 text-center my-auto">
                        <div class="content-img h-100 ">
                            <img src="{{slide.imgR}}" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="slider-awards" *ngIf="slide.id > 1">

            <div class="container">
                <div class="row">
                    <div class="col-12 text-center my-auto">
                        <div class="content-img" style="background-image: url({{slide.bg}});">
                            <img src="{{slide.logo}}" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>


        </section>




    </div>
</ngx-slick-carousel>

<!-- <section class="banner-hame-2025">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <img src="/assets/images/sorteo-2025/logo-causa.png" alt="">
                <h1>
                    PRÓXIMAMENTE
                </h1>
                <img data-aos="fade-right"  data-aos-delay="400" src="/assets/images/sorteo-2025/cars.png" alt="">
            </div>

        </div>
    </div>
</section> -->


<section id="lucky">
    <div class="container">
        <div class="row">

            <div class="col-12 text-center">
                <h2>Máquina de la suerte</h2>
                <p class="sub-h ">Descubre tu número de la suerte</p>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="content-machine">
                    <div class="text-center">
                        <img src="/assets/images/sorteo2025/aniversario.png" alt="Sorteo Anáhuac Aniversario"
                            class="img-fluid">
                    </div>
                    <div class="numbers-container aniv border-gradient-all box-s ">
                        <div class="numbers btn-gradient">
                            <ul id="list-n10">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>

                            </ul>
                        </div>
                        <div class="numbers btn-gradient">
                            <ul id="list-n11">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>
                        <div class="numbers btn-gradient">
                            <ul id="list-n12">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers btn-gradient">
                            <ul id="list-n13">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers btn-gradient">
                            <ul id="list-n14">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers btn-gradient">
                            <ul id="list-n15">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                    </div>

                    <div class="content text-center">
                        <div
                            class="buttons-generate d-flex justify-content-center align-items-center gap-3 mt-3 flex-column flex-lg-row">
                            <a *ngIf="!anivflag_buy" (click)="getBoletoRandomANIV();" class="btn-stack generate-number">
                                ¡Activa tu suerte aquí!
                            </a>

                            <a *ngIf="anivflag_buy_btn" (click)="sendTicketAniv();" class="btn-stack generate-number">
                                Comprar
                            </a>
                        </div>

                        <div *ngIf="anivflag_buy_loader" class="w-100 text-center mt-3">
                            <p>Generando tu número...</p>
                            <img src="/assets/images/sorteo2025/tickets.gif" class="img-fluid gif-ticket" width="170">
                        </div>

                    </div>

                </div>


            </div>

            <div class="col-lg-6 col-md-12 my-auto">
                <div class="content-machine magno-machine">
                    <div class="text-center">
                        <img src="/assets/images/sorteo2025/magno.png" alt="Sorteo Anáhuac Aniversario"
                            class="img-fluid mb-3">
                    </div>
                    <div class="numbers-container border-gradient-all-magno box-s">
                        <div class="numbers num-magno">
                            <ul id="list-n0">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>

                            </ul>
                        </div>
                        <div class="numbers num-magno">
                            <ul id="list-n1">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>
                        <div class="numbers num-magno">
                            <ul id="list-n2">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers num-magno">
                            <ul id="list-n3">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers num-magno">
                            <ul id="list-n4">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers num-magno">
                            <ul id="list-n5">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                    </div>

                    <div class="content text-center">
                        <div
                            class="buttons-generate d-flex justify-content-center align-items-center gap-3 mt-3 flex-column flex-lg-row">
                            <a *ngIf="!flag_buy" (click)="getBoletoRandom();"
                                class="btn-stack purple generate-number  mx-auto">

                                ¡Activa tu suerte aquí!
                            </a>



                            <a *ngIf="flag_buy_btn" (click)="sendTicket();"
                                class="btn-stack purple generate-number  mx-auto">
                                Comprar
                            </a>

                        </div>

                        <div *ngIf="flag_buy_loader" class="w-100 text-center mt-3">
                            <p>
                                Generando tu número...
                            </p>
                            <img src="/assets/images/sorteo2025/tickets.gif" class="img-fluid gif-ticket" width="170">

                        </div>

                    </div>



                </div>


                <!-- <div class="prox">
                    <p>PRÓXIMAMENTE <p>
                </div> -->



            </div>



        </div>
    </div>
</section>


<section class="ours">
    <div class="container">
        <div class="row">
            <div class="col-md-5 my-auto">
                <h3>
                    NUESTROS
                    SORTEOS
                </h3>
            </div>
            <div class="col-md-7 my-auto">
                <p>
                    Conoce todos nuestros sorteos y los increíbles premios que tenemos para ti.

                    <span class="d-block mt-md-4">
                        ¡Tú podrías ser el próximo ganador!
                    </span>
                </p>
            </div>
        </div>
    </div>
</section>


<section id="counters-box-cta">
    <div class="container">
        <div class="row">


            <div class="col-12">
                <div class="content-img aniv">
                    <div class="row">
                        <div class="col-lg-5  text-center mt-4">
                            <h5>Primer Premio</h5>
                            <p>
                                VALOR DE + DE 1.7 MILLONES DE PESOS
                            </p>

                            <img src="/assets/images/sorteo2025/logo-audi.png" class="img-fluid" alt="">
                        </div>
                        <div class="col-lg-4 offset-lg-3 my-auto text-center pt-3">
                            <img src="/assets/images/sorteo2025/logo-aniv.png" class="img-fluid"
                                alt="Sorteo Anáhuac Aniversario 2025" class="logo" width="260">
                            <p class="fecha mt-4">
                                FECHA
                                <img src="/assets/images/sorteo2025/calendar.png" alt="Calendario">
                                <span class="text-p">18 SEP</span>
                            </p>

                            <p>
                                SEDE <span class="text-p">UNIVERSIDAD ANÁHUAC MÉXICO CAMPUS NORTE</span>
                            </p>

                            <div class="counter-box" *ngIf="!flagShow">
                                <span class="content-day">
                                    <span class="day">
                                        {{ dias }}
                                    </span>
                                    <span class="text d-block">
                                        Dias
                                    </span>
                                </span>
                                <span class="point">.</span>

                                <span class="content-day">
                                    <span class="hours">
                                        {{ horas }}
                                    </span>
                                    <span class="text d-block">
                                        hrs
                                    </span>
                                </span>
                                <span class="point">.</span>

                                <span class="content-day">
                                    <span class="minutes">
                                        {{ minutos }}
                                    </span>
                                    <span class="text d-block">
                                        min
                                    </span>
                                </span>
                                <span class="point">.</span>

                                <span class="content-day">
                                    <span class="seconds">
                                        {{ segundos }}
                                    </span>
                                    <span class="text d-block">
                                        seg
                                    </span>
                                </span>
                            </div>



                            <a routerLink="/premios-sorteo-anahuac-aniversario" class="btn-stack btn-sorteo mr-2">
                                CONOCE LOS PREMIOS</a>
                            <a href="{{ urlMicrositioAniv }}" target="_blank"
                                class="btn-stack btn-sorteo-inside">COMPRA AQUÍ</a>


                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="content-img">
                    <div class="row">


                        <div class="col-lg-5 my-auto text-center">
                            <img src="/assets/images/sorteo2025/img-56.png" class="img-fluid p-md-0  p-4">
                            <h5>Primer Premio</h5>
                            <p>
                                VALOR DE + DE 12.5 MILLONES DE PESOS
                            </p>
                            <p class="text-p">
                                DEPARTAMENTO <span>AMUEBLADO</span>
                                <span class="d-block" style="color: #000;"> EN CANCÚN</span>
                                <span class="d-block">BREZZA TOWERS MAR</span>
                            </p>
                        </div>
                        <div class="col-lg-4 offset-lg-3 my-auto text-center pt-3">
                            <img src="/assets/images/sorteo2025/logo-magno-card.png" class="img-fluid"
                                alt="Sorteo Anáhuac 2025" class="logo">
                            <p class="fecha mt-4">
                                FECHA
                                <img src="/assets/images/sorteo2025/calendar.png" alt="Calendario">
                                <span class="text-p">20 NOV</span>
                            </p>

                            <p>
                                SEDE <span class="text-p">UNIVERSIDAD ANÁHUAC CANCÚN</span>
                            </p>

                            <div class="counter-box" *ngIf="!flagShow">
                                <span class="content-day">
                                    <span class="day">
                                        {{ day }}
                                    </span>
                                    <span class="text d-block">
                                        Dias
                                    </span>
                                </span>
                                <span class="point">.</span>

                                <span class="content-day">
                                    <span class="hours">
                                        {{ hours }}
                                    </span>
                                    <span class="text d-block">
                                        hrs
                                    </span>
                                </span>
                                <span class="point">.</span>

                                <span class="content-day">
                                    <span class="minutes">
                                        {{ minutes }}
                                    </span>
                                    <span class="text d-block">
                                        min
                                    </span>
                                </span>
                                <span class="point">.</span>

                                <span class="content-day">
                                    <span class="seconds">
                                        {{ seconds }}
                                    </span>
                                    <span class="text d-block">
                                        seg
                                    </span>
                                </span>
                            </div>


                            <a routerLink="/premios-sorteo-anahuac" class="btn-stack btn-sorteo mr-2"> CONOCE LOS
                                PREMIOS</a>
                            <a href="{{urlMicrositio}}" target="_blank"
                                class="btn-stack btn-sorteo-inside">COMPRA AQUÍ</a>


                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4">
                <div class="content-img oportuno1" style="height: 470px;">
                    <div class="header-top">
                        <h6>
                            1° SORTEO OPORTUNO
                        </h6>
                    </div>

                    <!-- <div class="counter-box">
                        <span class="content-day">
                            <span class="day">
                                {{ dias_egr }}
                            </span>
                            <span class="text d-block">
                                Dias
                            </span>
                        </span>
                        <span class="point">.</span>

                        <span class="content-day">
                            <span class="hours">
                                {{ horas_egr }}
                            </span>
                            <span class="text d-block">
                                hrs
                            </span>
                        </span>
                        <span class="point">.</span>

                        <span class="content-day">
                            <span class="minutes">
                                {{ minutos_egr }}
                            </span>
                            <span class="text d-block">
                                min
                            </span>
                        </span>
                        <span class="point">.</span>

                        <span class="content-day">
                            <span class="seconds">
                                {{ segundos_egr }}
                            </span>
                            <span class="text d-block">
                                seg
                            </span>
                        </span>
                    </div> -->

                    <div class="body-card">
                        <span>Primer premio</span>
                        <p>CHEQUE CERTIFICADO DE
                            <strong class="sg">$200,000.00</strong>
                        </p>
                        <p>
                            <!-- <strong>SEDE</strong>  -->
                            <strong style="color: #9d7fda; ">SEDE <span>UNIVERSIDAD ANÁHUAC MÉXICO CAMPUS NORTE</span>
                            </strong>
                        </p>
  


                    </div>

                    <div class="w-100 mx-auto text-center">
                        <a href="https://www.youtube.com/live/YX6xBoqrZUU" target="_blank"
                            class="btn-stack btn-sorteo-inside">¡REVIVE EL EN VIVO!</a>
                    </div>

                    <div class="footer-card text-center w-100 mx-auto">
                        <p>
                            FECHA <span> <img src="/assets/images/sorteo2025/calendar-icon.png" alt="">23 MAY</span>
                        </p>
                    </div>

                </div>
            </div>

            <div class="col-lg-4" [routerLink]="['/sorteo-oportuno']">
                <div class="content-img oportuno2" style="height: 470px;">
                    <div class="header-top">
                        <h6>
                            2° SORTEO OPORTUNO
                        </h6>
                    </div>

                    <!-- <div class="counter-box">
                        <span class="content-day">
                            <span class="day">
                                {{ dias_egr }}
                            </span>
                            <span class="text d-block">
                                Dias
                            </span>
                        </span>
                        <span class="point">.</span>

                        <span class="content-day">
                            <span class="hours">
                                {{ horas_egr }}
                            </span>
                            <span class="text d-block">
                                hrs
                            </span>
                        </span>
                        <span class="point">.</span>

                        <span class="content-day">
                            <span class="minutes">
                                {{ minutos_egr }}
                            </span>
                            <span class="text d-block">
                                min
                            </span>
                        </span>
                        <span class="point">.</span>

                        <span class="content-day">
                            <span class="seconds">
                                {{ segundos_egr }}
                            </span>
                            <span class="text d-block">
                                seg
                            </span>
                        </span>
                    </div> -->

                    <div class="body-card">
                        <span>Primer premio</span>
                        <p>CHEQUE CERTIFICADO DE
                            <strong class="sg">$200,000.00</strong>
                        </p>
                        <p>
                            <!-- <strong>SEDE</strong>  -->
                            <strong style="color: #ff8539;">SEDE <span>UNIVERSIDAD ANÁHUAC MÉXICO CAMPUS
                                    SUR</span></strong>
                        </p>
                   
                    </div>

                    <div class="footer-card text-center w-100 mx-auto" style="margin-top: 55px;">
                        <p>
                            FECHA <span> <img src="/assets/images/sorteo2025/calendar-icon.png" alt="">22 AGO</span>
                        </p>
                    </div>

                </div>
            </div>

            <div class="col-lg-4" [routerLink]="['/sorteo-oportuno']">
                <div class="content-img oportuno3" style="height: 470px;">
                    <div class="header-top">
                        <h6>
                            3° SORTEO OPORTUNO
                        </h6>
                    </div>

                    <!-- <div class="counter-box">
                        <span class="content-day">
                            <span class="day">
                                {{ dias_egr }}
                            </span>
                            <span class="text d-block">
                                Dias
                            </span>
                        </span>
                        <span class="point">.</span>

                        <span class="content-day">
                            <span class="hours">
                                {{ horas_egr }}
                            </span>
                            <span class="text d-block">
                                hrs
                            </span>
                        </span>
                        <span class="point">.</span>

                        <span class="content-day">
                            <span class="minutes">
                                {{ minutos_egr }}
                            </span>
                            <span class="text d-block">
                                min
                            </span>
                        </span>
                        <span class="point">.</span>

                        <span class="content-day">
                            <span class="seconds">
                                {{ segundos_egr }}
                            </span>
                            <span class="text d-block">
                                seg
                            </span>
                        </span>
                    </div> -->

                    <div class="body-card">
                        <span>Primer premio</span>
                        <p>CHEQUE CERTIFICADO DE
                            <strong class="sg">$200,000.00</strong>
                        </p>
                        <p>
                            <!-- <strong>SEDE</strong>  -->
                            <strong style="color:#e94a3c ;">SEDE <span>UNIVERSIDAD ANÁHUAC MÉXICO CAMPUS
                                    SUR</span></strong>
                        </p>
                     
                    </div>

                    <div class="footer-card text-center w-100 mx-auto" style="margin-top: 55px;">
                        <p>
                            FECHA <span> <img src="/assets/images/sorteo2025/calendar-icon.png" alt="">17 OCT</span>
                        </p>
                    </div>

                </div>
            </div>



            <!-- <div class="col-12">
                <img src="/assets/images/sorteo2025/prox-magno.jpg" alt="" class="img-fluid">
            </div> -->


        </div>
    </div>
</section>

<section class="news">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="input-group">
                    <div class="label-container">Newsletter</div>
                    <div class="input-wrapper">
                        <input type="text" placeholder="Tu correo aquí">
                        <button type="button">SUSCRIBIR</button>
                    </div>
                </div>
                <p>
                    Recibe promociones exclusivas, noticias destacadas y las actualizaciones más recientes de nuestro
                    blog directamente en tu correo.
                </p>
                <div class="checkbox-group">
                    <input type="radio" id="terms">
                    <small>He leído y acepto los términos y condiciones y las políticas de privacidad</small>
                </div>
            </div>
        </div>
    </div>
</section>




<section class="ours purple">
    <div class="container">
        <div class="row">
            <div class="col-md-5 my-auto">
                <h3>
                    ¡DESCUBRE TODO
                    LO QUE SOMOS!
                </h3>
            </div>
            <div class="col-md-7 my-auto">
                <p>
                    Explora nuestro propósito, conoce los increíbles premios que tenemos para ti, visita nuestro blog
                    lleno de historias inspiradoras y únete como colaborador para ser parte de algo más grande.

                    <span class="d-block mt-md-4">
                        ¡Hay mucho más por descubrir!
                    </span>
                </p>
            </div>
        </div>
    </div>
</section>

<section class="cta-buttons">
    <div class="container">
        <div class="row">

            <!-- Primera columna (Premios Magno y Aniversario) -->
            <div class="col-md-5">
                <a routerLink="/premios-sorteo-anahuac">
                    <img src="/assets/images/sorteo2025/cta-premios.png" class="img-fluid" alt="Premios Magno">
                </a>
                <!-- <a style="position: relative; display: inline-block;">
                    <img src="/assets/images/sorteo2025/proximamente.jpg" alt="Premios Magno" height="375" style="object-fit: cover;">
                    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; font-size: 36px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);">
                        Próximamente
                    </div>
                </a> -->


                <a routerLink="/premios-sorteo-anahuac-aniversario">
                    <img src="/assets/images/sorteo2025/cta-premio-aniv.png" class="img-fluid" alt="Premios Aniversario"
                        style="padding: 0 10px;">
                </a>
            </div>

            <!-- Segunda columna (Colabora y Premios Colaborador) -->
            <div class="col-md-3">
                <a  href="https://gana.sorteoanahuac.mx/colabmagno" target="_blank">
                    <img src="/assets/images/sorteo2025/colaborador-magno.png" class="img-fluid colabora"
                        alt="Colabora" style="padding: 0 15px ">
                </a>
                <a href="https://gana.sorteoanahuac.mx/colabaniv5" target="_blank">
                    <img src="/assets/images/sorteo2025/colaborador-aniversario.png" class="img-fluid colabora"
                        alt="Colabora" style="padding: 25px 15px">
                </a>
                <a>
                    <a routerLink="/premios-para-colaboradores">
                        <img src="/assets/images/sorteo2025/premios-col.png" class="img-fluid"
                            alt="Premios de Colaborador" style="padding: 25px 20px;">
                    </a>
                </a>
            </div>

            <!-- Tercera columna (Ganadores y Blog) -->
            <div class="col-md-3">
                <a [routerLink]="['/galeria']">
                    <img src="/assets/images/sorteo2025/cta-ganadores.png" class="img-fluid" alt="Nuestros Ganadores"
                        style="padding: 0px 9px 10px 10px;">
                </a>
                <a href="https://gana.sorteoanahuac.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/cta-blog.png" class="img-fluid" alt="Blog"
                        style="padding: 20px 15px;">
                </a>
            </div>

        </div>
    </div>
</section>





<!-- <section id="counters">
    <div class="container-fluid ">
        <div class="row">
            <div class="col-12">
                <h5>Siguiente sorteo:

                </h5>
            </div>
            <div class="col-lg-6 col-12 d-md-flex justify-content-center line mt-xl-0 mt-5 text-center ">
             
                    <span class="sorteo-opt ">
                        <a [routerLink]="['/sorteo-oportuno']">
                            tercer 
                            sorteo 
                            oportuno
                        </a>
                    </span>
                
                <div class="counter border-gradient-all text-center mt-xl-0 mt-4">
                    <div class="number-count">
                        <span>{{ dias }}</span>.<span>{{ horas }}</span>.<span>{{ minutos }}</span>.<span>{{ segundos }}</span>
                    </div>

                    <div class="labels text-center">
                        <span>DÍAS</span>
                        <span>HRS</span>
                        <span>MIN</span>
                        <span>SEG</span>
                    </div>
                </div>
               
            </div> -->

<!-- <div class="col-xl-4 col-lg-6 col-12 d-md-flex justify-content-center line mt-xl-0 mt-5 text-center">
              
                    <span class="sorteo-opt  sorteo-egr">
                        <a [routerLink]="['/sorteo-egresado-universidad-anahuac']"> 
                            SORTEO
                            <span class="d-lg-block">
                                Egresados
                            </span> 
                        </a>
                    </span>
               
                
                <div class="counter border-gradient-all text-center mt-xl-0 mt-4">
                    <div class="number-count">
                        <span>{{ dias_egr }}</span>.<span>{{ horas_egr }}</span>.<span>{{ minutos_egr }}</span>.<span>{{ segundos_egr }}</span>
                    </div>

                    <div class="labels text-center">
                        <span>DÍAS</span>
                        <span>HRS</span>
                        <span>MIN</span>
                        <span>SEG</span>
                    </div>
                </div>
               
            </div> 


            <div class="col-12 d-md-flex justify-content-center mt-xl-0 mt-5 text-center">
                
                    <span class="sorteo-opt  sorteo-mg">
                       <a href="https://sorteoanahuaccompra.sorteoanahuac.mx/compra-en-linea-boletos-sorteo-anahuac{{urlUtm}}" target="_blank">
                            SORTEO MAGNO 
                            <span class="d-lg-block">
                               2024
                            </span>  
                        </a>
                    </span>
              
                <div class="counter border-gradient-all text-center mt-xl-0 mt-4">
                    <div class="number-count">
                        <span>{{ day }}</span>.<span>{{ hours }}</span>.<span>{{ minutes }}</span>.<span>{{ seconds }}</span>
                        <span>¡PRÓXIMAMENTE!</span>
                    </div>

                    <div class="labels text-center">
                        <span>DÍAS</span>
                        <span>HRS</span>
                        <span>MIN</span>
                        <span>SEG</span>
                    </div>
                </div>
               
            </div>

           

        </div>
    </div>
</section> -->



<section id="parthers">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="titulo-container">
                    <hr>
                    <span>Nuestros Aliados</span>
                    <hr>
                </div>

                <a href="https://www.bosquereal.com.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/aliado1.png" class="img-fluid" alt="Brezza">
                </a>


                <a href="https://www.kia.com/mx/main.html" target="_blank">
                    <img src="/assets/images/sorteo2025/aliado2.png" class="img-fluid" alt="Boswue Real">
                </a>

                <a href="https://www.scotiabank.com.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/aliado3.png" class="img-fluid" alt="">
                </a>

                <a href="https://www.byd.com/mx" target="_blank">
                    <img src="/assets/images/sorteo2025/aliado4.png" class="img-fluid" alt="">
                </a>

                <a href="https://www.brezza.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/aliado5.png" class="img-fluid" alt="">
                </a>
                <a href="https://elorigen.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/aliado6.png" class="img-fluid" alt="">
                </a>
                <a href="https://www.santander.com.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/aliado7.png" class="img-fluid" alt="">
                </a>
                <a href="https://www.paypal.com/mx/home" target="_blank">
                    <img src="/assets/images/sorteo2025/aliado8.png" class="img-fluid" alt="">
                </a>

                <a href="https://www.audi.com.mx/" target="_blank">
                    <img src="/assets/images/sorteo2025/logo-audi-m.png" class="img-fluid" width="100">
                </a>


            </div>
        </div>
    </div>
</section>



<!-- Modal para compartir -->
<!-- <div class="modal fade pr-2" id="modal-share1" tabindex="-1" role="dialog" aria-labelledby="modal-share1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            
            <section class="share">
                <div class="container">
                    <div class="row">
                        <div class="col-12 text-center banner">
                            <h3>INVITACIÓN A <span>COMPRAR</span></h3>
                        </div>
                    </div>
                </div>
            </section>
            
            <section class="share-cta">
                <div class="container">
                    <div class="row">
                        <div class=" col-12 text-center">
                          
                            <p class="mb-4 mt-4"> Invita a tus amigos a comprar un boleto de sorteo Anáhuac, al hacerlo te da la oportunidad de ganar un premio como colaborador. </p>
                            <div class="content-btn ">
                                <a href="https://www.facebook.com/sharer/sharer.php?u={{link}}" target="_blank">
                                    <img src="/assets/images/pasa-la-voz/facebook.png" >
                                </a>
                                <a href="https://www.instagram.com/" target="_blank">
                                    <img src="/assets/images/pasa-la-voz/insta.png" >
                                </a>
                                <a href="https://api.whatsapp.com/send?text=Compra%20un%20boleto%20de%20Sorteo%20Anáhuac%20y%20gana%20fabulosos%20premios%0A¡Apoya%20a%20la%20educación!{{link}}" target="_blank">
                                    <img src="/assets/images/pasa-la-voz/whats.png">
                                </a>
                                <a href="https://twitter.com/intent/tweet?text=Compra%20un%20boleto%20de%20Sorteo%20Anáhuac%20y%20gana%20fabulosos%20premios%0A¡Apoya%20a%20la%20educación! {{link}}&" target="_blank">
                                    <img src="/assets/images/pasa-la-voz/tw.png" >
                                </a>
                            </div>
            
                            <p class="mt-4 mb-4 pb-0 copy">Puedes copiar este link para compartirlo donde quieras.</p>
                            <input id="link" value="{{link}}" readonly>
                            <div class="content">
                                <a (click)="clickbtn()" class="btn-d"> Copiar link</a>
                            </div>
                            <div *ngIf="select" class="alert alert-success mt-4 animate__animated  animate__fadeInUpBig" role="alert" >
                                Texto copiado.
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    </div>
</div> -->


<!-- Modal send-->
<div class="modal fade" id="modal-message" tabindex="-1" role="dialog" aria-labelledby="modal-msi" aria-hidden="true">
    <div class="modal-dialog  modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center no-padding">


                <img src="/assets/images/sorteo2024/banners/aviso.jpg" alt="Aviso" class="img-fluid">


            </div>

        </div>
    </div>
</div>